import { casOpsApi, CollectionModel, QueryTag, TagList } from '../api';
import { ModelWithId } from './commonModels';

export interface AssetGroupModel extends ModelWithId {
  name: string; // Max 128 chars with regex "^[a-zA-Z0-9-_\\.\\s]+$"
  desc: string; // description. Max 255 chars
  used: boolean; // disable delete
  totG: number; // total number of geofences associated with this asset group
  totA: number; // total numer of assets associated with this asset group
}

export interface CreateAssetGroupModel extends Pick<AssetGroupModel, 'name' | 'desc'> {}

export interface EditAssetGroupModel extends Pick<AssetGroupModel, 'name' | 'desc'> {}

export interface AssetGroupFormModel extends CreateAssetGroupModel, EditAssetGroupModel {}

export const assetGroupsApi = casOpsApi.injectEndpoints({
  endpoints: build => ({
    listAssetGroups: build.query<AssetGroupModel[], void>({
      query: () => 'api/assetgroups',
      transformResponse: (response: CollectionModel<AssetGroupModel>, meta, arg) => response.items,
      providesTags: (result, error, arg) =>
        result ? [{ type: QueryTag.AssetGroup, id: TagList }] : [],
    }),
    getAssetGroup: build.query<AssetGroupModel, ModelWithId>({
      query: ({ id }) => `api/assetgroups/${id}`,
      providesTags: (result, error, { id }) =>
        result ? [{ type: QueryTag.AssetGroup, id: id }] : [],
    }),
    createAssetGroup: build.mutation<void, CreateAssetGroupModel>({
      query: body => ({
        url: 'api/assetgroups',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: QueryTag.AssetGroup, id: TagList }],
    }),
    editAssetGroup: build.mutation<void, EditAssetGroupModel & ModelWithId>({
      query: ({ id, ...body }) => ({
        url: `api/assetgroups/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, { id }) =>
        !error
          ? [
              { type: QueryTag.AssetGroup, id: TagList },
              { type: QueryTag.AssetGroup, id: id },
            ]
          : [],
    }),
    deleteAssetGroup: build.mutation<void, ModelWithId>({
      query: ({ id }) => ({
        url: `api/assetgroups/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { id }) =>
        !error
          ? [
              { type: QueryTag.AssetGroup, id: TagList },
              { type: QueryTag.AssetGroup, id: id },
            ]
          : [],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListAssetGroupsQuery,
  useGetAssetGroupQuery,
  useCreateAssetGroupMutation,
  useEditAssetGroupMutation,
  useDeleteAssetGroupMutation,
} = assetGroupsApi;
